import { render, staticRenderFns } from "./Stones.vue?vue&type=template&id=e7c8a962&scoped=true"
import script from "./Stones.vue?vue&type=script&lang=js"
export * from "./Stones.vue?vue&type=script&lang=js"
import style0 from "./Stones.vue?vue&type=style&index=0&id=e7c8a962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c8a962",
  null
  
)

export default component.exports